<template>
    <div>
        <carousel></carousel>
        <div v-if="user == null">
            <register></register>
        </div>
        <div v-else>
            <upload></upload>
        </div>

        <photoBlock :p_date="date" v-for="date in datelist" v-bind:key="date.date"></photoBlock>

    </div>
</template>

<script>
/* eslint-disable */
import carousel from './components/Carousel'
import register from './components/Register'
import upload from './components/Upload'
import photoBlock from './components/photoBlock'

export default {
    name: 'app',
    components: {
        carousel,
        register,
        upload,
        photoBlock,
    },
    props: {

    },
    data: function () {
        return {
            user: {},
            // datelist: [],
        }
    },
    methods: {
        checkUser: function () {
            this.$axios.get(
                this.$config.common.apiPath + '/loginCheck/'
            )
            .then(response => {
                var rtn = response.data
                if (rtn.status === 'OK') {
                    this.user = {
                        tuid: rtn.tuid
                    }
                } else {
                    this.user = null
                }
            })
            .catch(function (error) {
                this.user = null
            })
        },
    },
    mounted () {
        this.checkUser()
        this.$store.dispatch('updateFullList', this.$config.common.apiPath)
    },
    computed: {
        datelist () {
            return this.$store.state.photoList
            // return this.$store.getters.photoList
        }
    }
}
</script>

<style>
body {
    margin: 0px;
}
.header {
    font-size: 2em;
    background-color: #e0e0e0;
    line-height: 60px;
    text-align: center;
}
</style>